export const HighestWeight = 5;
export const ProgressBarWidth = 30;
